import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const OverviewGate = React.lazy(() => import("./Overview.gate"));

const OverviewLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <OverviewGate />
  </React.Suspense>
);

export default () => <OverviewLoadable />;
